import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function BabyIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" strokeWidth="1.125" strokeLinecap="round"
            strokeLinejoin="round" />
      <path
        d="M8.625 12.938a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Zm6.75 0a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Z"
        fill="currentColor" />
      <path d="M14.484 15.75a4.491 4.491 0 0 1-4.968 0M12 3c-1.5 1.875-1.5 3.75-1.5 3.75a1.5 1.5 0 0 0 3 0"
            stroke="currentColor" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
    </BaseIcon>
  );
}
